









































import Api from "./Api";
import {Component, Inject} from "vue-property-decorator";
import {AllUsersReportRow, DateTime, PhoneNumber, UnverifiedCompany} from "../../../modules/models";
import Routes from "../../../modules/Routes";
import UserRequired from "../../UserRequired";

@Component
export default class AllUsersReport extends UserRequired {
    @Inject()
    api!: Api;

    loading = false;
    items: AllUsersReportRow[] = [];

    get company() {
        return this.baseApi.company;
    }

    async loadResult() {
        if(this.company != null) {
            this.loading = true;
            try {
                this.items = await this.api.fetchAllUsersReport(this.company.orgNum);
            } catch (err) {
                this.emitError(err);
            } finally {
                this.loading = false;
            }
        }
    }

    headers = [
        {text: "Fornavn", value: "firstName", align: "left"},
        {text: "Etternavn", value: "lastName", align: "left"},
        {text: "Født", value: "birthDate", align: "left"},
        {text: "Telefon", value: "phones", align: "left"},
        {text: "Firma", value: "companies", align: "left"},
        {text: "HMS-kortnr", value: "cardNums", align: "left"},
        {text: "", value: "personGuid", align: "left"},
    ];

    phonesToCommalist(phones: PhoneNumber[]) {
        return phones.map((p) => p.splitformat()).join(", ");
    }

    companiesToCompanyNames(companies: UnverifiedCompany[]) {
        return companies.map((c) => c.name).join(", ");
    }

    cardNumsToCommalist(cardNums: number[]) {
        return cardNums.map((n) => `${n}`).join(", ");
    }

    formatDate(dt: DateTime): string | null {
        return dt != null ? dt.toLocalDate() : null;
    }

    get distinctCompanies() {
        const ret: UnverifiedCompany[] = [];
        for(let i of this.items) {
            for(let c of i.companies) {
                if(c.orgNum != null && c.name != null && c.name.length > 0 && ret.indexOf(c) == -1) {
                    ret.push(c);
                }
            }
        }
        return ret;
    }

    filterOrgNums: number[] = [];

    get filteredItems() {
        if(this.filterOrgNums.length == 0) {
            return this.items;
        } else {
            return this.items.filter((i) => i.companies.some((c) => c.orgNum != null && this.filterOrgNums.indexOf(c.orgNum) > -1 ));
        }
    }

    showUser(personGuid: string) {
        window.location.assign(Routes.pages.useradmin(personGuid));
    }

    get excelReportUrl() {
        const on = this.company && this.company.orgNum || 0;
        return Routes.allUsersReportXlsx(on, this.filterOrgNums);
    }

    created() {
        this.loadResult();
    }
}
